"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectGroup = exports.PrivateSelectGroup = void 0;

var tslib_1 = require("tslib");

var ui_checkbox_1 = require("@hopin-team/ui-checkbox");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_radio_buttons_1 = require("@hopin-team/ui-radio-buttons");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("./context");

var SelectGroup = function SelectGroup(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      isSingle = _a.isSingle,
      children = _a.children,
      hasErrors = _a.hasErrors,
      _b = _a.pattern,
      pattern = _b === void 0 ? 'primary' : _b,
      rest = tslib_1.__rest(_a, ["className", "__UIScope", 'data-testid', "isSingle", "children", "hasErrors", "pattern"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'SelectGroup',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var isInverse = pattern === 'inverse';
  var contextValue = (0, react_1.useMemo)(function () {
    return {
      isSingle: !!isSingle,
      isInverse: isInverse,
      hasErrors: hasErrors
    };
  }, [isSingle, isInverse, hasErrors]);
  return react_1.default.createElement(context_1.SelectItemsContext.Provider, {
    value: contextValue
  }, isSingle ? react_1.default.createElement(ui_radio_buttons_1.RadioGroup, tslib_1.__assign({
    className: rootClasses,
    "data-testid": testID,
    pattern: pattern
  }, rest), children) : react_1.default.createElement(ui_checkbox_1.CheckboxGroup, tslib_1.__assign({
    className: rootClasses,
    "data-testid": testID,
    pattern: pattern
  }, rest), children));
};

exports.PrivateSelectGroup = SelectGroup;
SelectGroup.displayName = 'SelectGroup';
var SelectGroupWithSpace = (0, ui_helper_with_space_1.withSpace)(SelectGroup);
exports.SelectGroup = SelectGroupWithSpace;